import { Component, OnInit } from '@angular/core';
import { PaymentService, ProductDisplay } from 'src/app/payment/payment.service';

@Component({
    selector: 'sub-pricing',
    templateUrl: './sub-pricing.component.html',
    styleUrls: ['./sub-pricing.component.css'],
    standalone: false
})
export class SubPricingComponent implements OnInit{

  billingToggle: boolean = true;

  activeFaqIndex: number | null = null;
  products: ProductDisplay[];
  selectedProduct: ProductDisplay;



  constructor(private paymentService: PaymentService){}

  toggleFaq(index: number): void {
    this.activeFaqIndex = this.activeFaqIndex === index ? null : index;
    console.log(this.activeFaqIndex);
  }

  async ngOnInit(): Promise<void> {
    this.products = await this.paymentService.getProducts();
    this.selectedProduct = this.products[0];

  }

}
